module.exports = __webpack_public_path__ + "img/spade-high.1378f7b6.png";